import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Theme } from "@material-ui/core";
import CancelIcon from '@material-ui/icons/CancelOutlined';
import { Result } from '@zxing/library';
import React from "react";
import BarcodeScanner from './BarcodeScanner';


const useStyles = makeStyles((theme: Theme) => ({
  title: {
    zIndex: 1,
    color: 'white',
  },
  cancelButton: {
    color: 'white',
  },
  dialogRoot: {
    '& .MuiDialog-paper': {
      overflow: 'hidden'
    }
  },
  dialogContent: {
    padding: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  }
}));

export default function Component(props: {
  dialogOpen: boolean,
  onBarcodeUpdate: (arg0: unknown, arg1?: Result) => void,
  onCancel: () => void,
})
{
  const classes = useStyles();
  if(!props.dialogOpen) return null;
  return (
    <Dialog
      fullScreen
      open={props.dialogOpen}
      className={classes.dialogRoot}
    >
      <DialogTitle className={classes.title}>Vonalkód beolvasás</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <BarcodeScanner
          onUpdate={props.onBarcodeUpdate}
        />
      </DialogContent>
      <DialogActions>
        <Button className={classes.cancelButton} startIcon={<CancelIcon />} onClick={props.onCancel}>Bezár</Button>
      </DialogActions>
    </Dialog>
  );
}
